import styled from "styled-components";

export const ThirdFoldWrapper = styled.div`
  margin-top: 64px;
`;
